import type { FC } from "preact/compat";
import type { VisibilityCheckboxProps } from "./interfaces";
import VisibilityIcon from "@material-design-icons/svg/outlined/visibility.svg";
import VisibilityOffIcon from "@material-design-icons/svg/outlined/visibility_off.svg";
import cn from "classnames";

const VisibilityCheckbox: FC<VisibilityCheckboxProps> = ({
    checked,
    className,
    label,
    ...rest
}) => (
    <label
        className={cn(
            "flex items-center cursor-pointer fill-current hover:text-sky-500 text-gray-600",
            className && String(className)
        )}
    >
        <input
            type="checkbox"
            className="peer w-0 h-0 opacity-0 absolute"
            checked={checked}
            {...rest}
        />
        {checked ? (
            <VisibilityIcon className="w-5 h-5 mr-2 peer-focus:text-sky-500" />
        ) : (
            <VisibilityOffIcon className="w-5 h-5 mr-2 peer-focus:text-sky-500" />
        )}
        <span className="peer-focus:text-sky-500">{label}</span>
    </label>
);

export default VisibilityCheckbox;
